//Dependencies
import React, { useState, useEffect } from 'react';

// Components
import InputField from '../../../global_components/form_components/InputField';

const AccountContent = () => {
  const [userDetails, setUserDetails] = useState({
    email_Address: '', 
    full_Name: '', 
    position: '', 
    admin: 0,
    status: ''
  });
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await fetch("https://wad-backend.ws381566.remote.ac/getUserAccountDetails.php", {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        });
        
        const result = await response.json();
        
        if (result.status === "success") {
          setUserDetails(result.user);
        } else {
          setStatusMessage(result.message || "Failed to fetch user details");
        }
      } catch (error) {
        setStatusMessage(error.message);
      }
    };

    fetchUserDetails();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");
    
    const formData = {
      accountEmailAddress: e.target.accountEmailAddress.value,
      accountDepartment: e.target.accountDepartment.value,
      accountFullName: e.target.accountFullName.value,
      accountPassword: e.target.accountPassword.value,
    };

    try {
      const response = await fetch("https://wad-backend.ws381566.remote.ac/editUserAccountDetails.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        mode: "cors",
      });
      const result = await response.json();
      setStatusMessage(result.message);
      if (result.success === true) {
        window.location.href = '/dashboard/account';
      }
    } catch (error) {
      setStatusMessage(error.message);
    } finally {}
  };

  return (
    <div className='flex flex-col items-center justify-start gap-10 w-full'>
      <div className='flex flex-col items-start justify-center p-6 sm:p-8 md:p-10 rounded-sm shadow-sm border border-[#DCDCDC] border-b-[#06BD60] border-b-2 w-full max-w-md sm:max-w-lg' id='accountInfoContainer'>
        <div className='w-full flex items-center justify-end gap-3 mb-5'>
          <h4 className='text-base font-normal'>{userDetails.status}</h4>
          <div className='w-3 h-3 rounded-lg bg-green-400'></div>
        </div>

        <div className='flex flex-col items-start mb-10 w-full'>
          <div className='bg-[#06BD60] p-2 mb-4 rounded-sm'>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
          <h2 className='text-3xl sm:text-4xl font-semibold mb-4'>{userDetails.full_Name}</h2>
          <h4 className='text-base font-normal'>{userDetails.position}</h4>
          <h4 className='text-base font-normal'>{userDetails.admin === 0 ? 'Regular user' : 'Admin'}</h4>
          {statusMessage && <h4 className="text-red-500 mt-2">{statusMessage}</h4>}
        </div>

        <form className='w-full' onSubmit={handleSubmit}>
          <InputField 
            for='accountEmailAddress' 
            name='accountEmailAddress' 
            labelText='Email address' 
            inputType='email' 
            inputRequired='required' 
            value={userDetails.email_Address || ''} 
            overrideStyles='mb-4' 
          />
          <InputField 
            for='accountDepartment' 
            name='accountDepartment' 
            labelText='Department' 
            inputType='text' 
            inputRequired='required' 
            value={userDetails.position || ''} 
            overrideStyles='mb-4' 
          />
          <InputField 
            for='accountFullName' 
            name='accountFullName' 
            labelText='Full name' 
            inputType='text' 
            inputRequired='required' 
            value={userDetails.full_Name || ''} 
            overrideStyles='mb-4' 
          />
          <InputField 
            for='accountPassword' 
            name='accountPassword' 
            labelText='Password' 
            inputType='password' 
            inputRequired='required' 
            overrideStyles='mb-4' 
          />
          <button type='submit' className='py-2 px-5 bg-[#06BD60] text-white rounded-sm font-semibold cursor-pointer mt-5'>
            Save
          </button>
        </form>
      </div>
    </div>
  )
}

export default AccountContent;